import {Component} from 'panel';

import {KEY_VALUES} from 'common/util/dom';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

interface InsightsFormulaEditorState {
  label: string;
  value: string;
}

export class InsightsFormulaEditor extends Component<InsightsFormulaEditorState> {
  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        label: ``,
        value: ``,
      },

      helpers: {
        handleLabelInput: (ev) => {
          this.update({label: ev.target.value});
        },
        handleLabelKeydown: (ev) => {
          this.handleInputKeydown(ev);
        },
        handleValueInput: (ev) => {
          this.update({value: ev.target.value.toUpperCase()});
        },
        handleValueKeydown: (ev) => {
          this.handleInputKeydown(ev);
        },
        handleValueInsert: (vnode) => {
          requestAnimationFrame(() => {
            vnode.elm.focus();
          });
        },
        handleSaveClick: () => {
          this.saveFormula();
        },
      },
    };
  }

  set label(label) {
    this.update({label});
  }

  set value(value) {
    this.update({value});
  }

  handleInputKeydown(ev) {
    if (ev.key === KEY_VALUES.ENTER) {
      ev.preventDefault();
      this.saveFormula();
    }
  }

  saveFormula() {
    if (!this.state.value) {
      return;
    }

    this.dispatchEvent(new CustomEvent(`save`, {detail: this.state}));
    this.update(this.config.defaultState);
  }
}

export const InsightsFormulaEditorEl = defineAndMakeJsxFactory(`insights-formula-editor`, InsightsFormulaEditor);
export const InsightsFormulaEditorReact = panel2react(`insights-formula-editor`, InsightsFormulaEditor);
